import React from 'react';
import './all-rights.scss';

const AllRightsReserved = () => (
  <div className="reserved">2020-2025 All Rights Reserved Peak Mind Inc.</div>
);

export default AllRightsReserved;
